function syncHeight() {
  const documentElementClientHeight = document.documentElement.clientHeight;
  const windowOuterHeight = window.outerHeight;
  const windowInnerHeight = window.innerHeight;

  let height = documentElementClientHeight;

  // [iOS] standalone
  if ((navigator as Navigator & { standalone?: boolean }).standalone) {
    height = windowOuterHeight;
  }

  document.documentElement.style.setProperty(`--screen-height`, `${height}px`);

  document.documentElement.style.setProperty(
    `--document-element-client-height`,
    `${documentElementClientHeight}px`,
  );
  document.documentElement.style.setProperty(
    `--window-outer-height`,
    `${windowOuterHeight}px`,
  );
  document.documentElement.style.setProperty(
    `--window-inner-height`,
    `${windowInnerHeight}px`,
  );
}

export default () => {
  syncHeight();
  window.addEventListener('resize', syncHeight);
  window.addEventListener('orientationchange', syncHeight);
  setInterval(syncHeight, 1000);
};
